export default "__VITE_ASSET__BRxxW$Ss__"